import api from '@/apis'
import { API_PREFIX } from '@/constants'
import type { PatchOrderBody, PatchOrderResponse } from '@/payment/types'

/**
 * 밀봉비닐 주문 수량 변경.
 *
 * 백엔드 명세 (2026-05-27 확정):
 *  - PATCH /order/api/v2/product-orders/{orderId}/quantity
 *  - body: { quantity: number } 단일 필드만
 */
export const apiPatchOrder = async (orderId: number, body: PatchOrderBody): Promise<PatchOrderResponse> => {
  return api.patch(`${API_PREFIX.ORDER}/product-orders/${orderId}/quantity`, body)
}
